if (!Enum) {
    var Enum = {};
}

Enum.BODY_PART = {
    LEFT: 'LEFT',
    RIGHT: 'RIGHT',
    LEFT_AND_RIGHT: 'LEFT_AND_RIGHT'
};

Object.freeze(Enum.BODY_PART);
